import tableToolbarTemplate from '../../../public/views/tableToolbar.html';
/**
 * @ngdoc directive
 * @name directiveTableToolbar
 * @restrict A
 *
 * @description
 * Directive toolbar section.
 */
export default function () {
    return {
        restrict: 'E', // Only attribute name can be used for directive definition
        controller: 'directiveTableToolbarCtrl', // Executes before compile
        scope: {},
        replace: true,
        template: tableToolbarTemplate
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/tableToolbar.js